import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  selectedImage: null,
  selectedImageId: null,
  isLoading: false,
  isDetailLoading: false,
  error: null,
  detailError: null,
  success: null,
};

const fieldImagesSlice = createSlice({
  name: "fieldImages",
  initialState,
  reducers: {
    fetchFieldImagesStart(state) {
      state.isLoading = true;
      state.data = [];
      state.error = null;
      state.success = false;
      state.selectedImage = null;
      state.selectedImageId = null;
      state.isDetailLoading = false;
      state.detailError = null;
    },
    fetchFieldImagesSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    fetchFieldImagesFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    fetchFieldImageDetailStart(state, action) {
      state.isDetailLoading = true;
      state.detailError = null;
      state.selectedImageId = action.payload?.image_id ?? null;
    },
    fetchFieldImageDetailSuccess(state, action) {
      state.isDetailLoading = false;
      if (String(action.payload?.id) === String(state.selectedImageId)) {
        state.selectedImage = action.payload;
      }
    },
    fetchFieldImageDetailFailure(state, action) {
      state.isDetailLoading = false;
      state.detailError = action.payload;
    },
  },
});

export const {
  fetchFieldImagesStart,
  fetchFieldImagesSuccess,
  fetchFieldImagesFailure,
  fetchFieldImageDetailStart,
  fetchFieldImageDetailSuccess,
  fetchFieldImageDetailFailure,
} = fieldImagesSlice.actions;
export default fieldImagesSlice.reducer;
